import React, { useState } from 'react';
import { CreditCard, History } from 'lucide-react';
import { PaymentAmountModal } from './PaymentAmountModal';
import { useModalWidth } from '../hooks/useModalWidth';

export function PaymentOptionsModal({ 
  isOpen, 
  onClose, 
  onPayNow, 
  onViewHistory, 
  productType,
  totalAmount,
  currency = 'GHS',
  status
}) {
  // Check if policy is inactive or expired - disable pay now button
  const statusLower = status ? String(status).toLowerCase() : '';
  const isInactive = statusLower === 'inactive' || statusLower === 'expired';
  const modalWidth = useModalWidth();
  const [showAmountModal, setShowAmountModal] = useState(false);

  if (!isOpen) return null;

  const handlePaymentTypeSelected = (paymentData) => {
    console.log('Payment type selected:', paymentData);
    onPayNow(paymentData);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.18)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 18,
          minWidth: 320,
          maxWidth: modalWidth,
          width: '90%',
          maxHeight: '85vh',
          overflowY: 'auto',
          boxShadow: '0 8px 40px 0 rgba(0,0,0,0.13)',
          padding: 0,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: '24px 32px 20px 32px' }}>
          <div className="modal-header-title" style={{ 
            fontWeight: 800, 
            color: '#222', 
            marginBottom: 6, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between' 
          }}>
            <span>Payment Options</span>
            <button 
              onClick={onClose} 
              style={{ 
                background: 'none', 
                border: 'none', 
                fontSize: 22, 
                color: '#888', 
                cursor: 'pointer', 
                marginLeft: 12, 
                fontWeight: 700, 
                lineHeight: 1 
              }} 
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <p className="modal-header-desc" style={{ color: '#888', marginBottom: 0, marginTop: 0 }}>
            Choose an action for your {productType} policy
          </p>
        </div>

        {/* Options */}
        <div style={{ padding: '0 32px 32px 32px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <button
            onClick={() => {
              if (isInactive) return;
              console.log('Pay Now clicked in PaymentOptionsModal. Opening amount modal. Total amount:', totalAmount);
              setShowAmountModal(true);
            }}
            disabled={isInactive}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '20px 24px',
              border: isInactive ? '2px solid #ccc' : '2px solid #00a651',
              borderRadius: 14,
              background: isInactive ? '#f5f5f5' : '#fff',
              cursor: isInactive ? 'not-allowed' : 'pointer',
              boxShadow: isInactive ? 'none' : '0 2px 8px 0 rgba(0,166,81,0.10)',
              opacity: isInactive ? 0.6 : 1,
            }}
          >
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: isInactive ? '#ccc' : '#00a651',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}>
              <CreditCard size={24} color="#fff" />
            </div>
            <div style={{ textAlign: 'left', flex: 1 }}>
              <div className="modal-option-title" style={{ fontWeight: 700, color: isInactive ? '#999' : '#00a651', marginBottom: 4 }}>
                {isInactive ? 'Pay Now (Disabled)' : 'Pay Now'}
              </div>
              <div className="modal-option-desc" style={{ color: '#666', lineHeight: 1.4 }}>
                {isInactive 
                  ? 'Payments are disabled for inactive policies' 
                  : `Initiate a new payment for your ${productType} policy`}
              </div>
            </div>
          </button>

          <button
            onClick={() => {
              onViewHistory();
              onClose();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '20px 24px',
              border: '1px solid #ddd',
              borderRadius: 14,
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#f8f9fa',
              border: '1px solid #ddd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}>
              <History size={24} color="#666" />
            </div>
            <div style={{ textAlign: 'left', flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#333', marginBottom: 4 }}>
                View Payment History
              </div>
              <div className="modal-option-desc" style={{ color: '#666', lineHeight: 1.4 }}>
                See your past {productType} payments and transactions
              </div>
            </div>
          </button>
        </div>
      </div>
      
      {/* Payment Amount Modal */}
      <PaymentAmountModal
        isOpen={showAmountModal}
        onClose={() => setShowAmountModal(false)}
        onPaymentTypeSelected={handlePaymentTypeSelected}
        productType={productType}
        totalAmount={totalAmount}
        currency={currency}
      />
    </div>
  );
}
